@if(loader){
    <app-loader></app-loader>
}
<p-card>
    <p-dataView #dv [value]="products" [layout]="layout">
        <ng-template let-product pTemplate="list" let-products>
            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">
                    <div>
                        <p-button label="New" class="p-button-outlined" (click)="Createproduct()" icon="pi pi-plus-circle"
                            size="small" pTooltip="Create Product"></p-button>
            
                    </div>
            
                    <div class="flex align-items-center ml-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"class=" p-inputtext-sm"
                                (keyup.enter)="searchProduct()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>
                        </span>
                        <p-button icon="pi pi-search" (onClick)="searchProduct()" [ngStyle]="{ height: '35px' }" [raised]="true"
                            [size]="'small'" severity="info" class="ml-2"></p-button>
                    </div>
            
                    <p-button *ngIf="selectedProduct && selectedProduct.length == 1" label="Edit" (click)="editProduct()"
                        class="p-button-outlined ml-2" icon="pi pi-user-edit" severity="secondary" size="small"></p-button>
                    <p-button *ngIf="selectedProduct && selectedProduct.length > 0" label="Delete" (click)="deleteProduct()"
                        class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger" size="small"></p-button>
                </div>
            
                <h2 class="mb-0 fw-bold page-title-center" style="top: -7px;">
                    Product List
                </h2>
            
                <div class="flex align-items-center">
                    <div>
                        <p-button label="Report" class="p-button-outlined" (click)="showReport(products)" icon="pi pi-file-export"
                            size="small"></p-button>
                    </div>&nbsp;
                    <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true" severity="info"></p-button>
                    &nbsp;
                    <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                </div>
            </div>


            <!-- <p-table #dt1 [value]="products" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-striped"
            [tableStyle]="{'min-width': '50rem'}" [globalFilterFields]="['productCode', 'productName']" [paginator]="true" [rows]="10" > -->
            <p-table #dt1 [value]="products" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped" 
                responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true"
                [loading]="loading" [rows]="10" [globalFilterFields]="['productCode', 'productName','salesPrice','standardCost','isActive']"
                (onPage)="loadProducts($event)" [(selection)]="selectedProduct"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10 ,15, 20]" [rowHover]="true" [selectionPageOnly]="true">


                <ng-template pTemplate="header">
                    <tr>
                        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <!-- <th>Image</th> -->
                        <th pSortableColumn="productCode">Prod Code<p-sortIcon field="productCode"></p-sortIcon></th>
                        <th>Product Name </th>
                        <th style="text-align: right;">QOH</th>
                        <th style="text-align: right;">Q-Avail</th>
                        <th style="text-align: right;" pSortableColumn="salesPrice">Sale Price <p-sortIcon field="salesPrice"></p-sortIcon></th>
                        <th style="text-align: right;" pSortableColumn="standardCost">Cost <p-sortIcon field="standardCost"></p-sortIcon></th>
                        <th style="text-align: right;">Product Type</th>
                        <th style="text-align: right;">HSN Code</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td> <p-tableCheckbox [value]="product"></p-tableCheckbox> </td>
                        <!-- <td><p-image
                            [src]="product.productImage"
                            [alt]="product.productImage ? 'Product Image' : 'No Image Available'"
                            width="30"
                            [preview]="true">
                          </p-image></td> -->
                        <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editProduct(product)">
                            {{product.productCode}} </td>
                        <td>{{product.productName}}</td>
                        <td class="text-right" [ngClass]="{'negative': product.quantityOnHand < 0 || product.quantityOnHand == null, 
                                        'positive': product.quantityOnHand >= 0}">
                            {{ (product.quantityOnHand || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </td>
                        
                        <td class="text-right" [ngClass]="{'negative': product.quantityAvailable < 0 || product.quantityAvailable == null, 
                                        'positive': product.quantityAvailable >= 0}">
                            {{ (product.quantityAvailable || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            }}
                        </td>

                        <!-- <td class="text-right {{ product.quantityOnHand < 0 || product.quantityOnHand == null ? 'negative' : 'positive' }}">
                          {{ (product.quantityOnHand || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </td>
                        <td class="text-right {{ product.quantityAvailable < 0 || product.quantityAvailable == null ? 'negative' : 'positive' }}">
                          {{ (product.quantityAvailable || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </td> -->
                        <td class="text-right">
                            <span>₹ {{ (product.salesPrice || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </td>
                          <td class="text-right">
                            <span>₹ {{ (product.standardCost || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </td>
                          <td class="text-right">{{product.productTypeName }}</td>

                        <td style="text-align: right;"><span> {{ product.hsnCode.toLocaleString()}}</span>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10">No Records found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-template>

        <ng-template let-product pTemplate="grid" let-products>

            <!-- <div class="flex justify-content-end">
                <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
            </div> -->
            <div class="flex justify-content-between align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" (click)="Createproduct()" icon="pi pi-plus-circle"
                        size="small"></p-button>
                    <p-button *ngIf="selectedProduct && selectedProduct.length > 0" label="Delete"
                        (click)="deleteProduct()" class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger"
                        size="small"></p-button>
                    <p-button *ngIf="selectedProduct && selectedProduct.length == 1" label="Edit"
                        (click)="editProduct()" class="p-button-outlined ml-2 " icon="pi pi-user-edit"
                        severity="secondary" size="small"></p-button>

                </div>
                <div class="flex">
                    <div class="flex align-items-center">
                        <p-button icon="pi pi-refresh" size="small" (onClick)="getProducts()" [rounded]="true"
                            severity="info"></p-button>
                    </div>&nbsp;
                    <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                </div>
            </div>

            <div class="grid grid-nogutter" style="max-height: 600px; overflow-y: auto;">
                <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2" *ngFor="let product of products">
                    <div class="p-4 border-1 surface-border surface-card border-round" style="height: 200px;">
                        <div class="flex flex-column align-items-center gap-1 py">
                            <img class="zoom w-7 shadow-2 border-round" [src]="product.productImage"
                                [alt]="product.productName" />
                            <div class="text-1xl font-bold text-primary truncate">{{product.productCode}} - {{
                                product.productName }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>
    </p-dataView>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
